import React from 'react';
import ResizeObserver from 'resize-observer-polyfill';
import {debounce} from 'lodash';
import PropTypes from 'prop-types';
import Card from 'common/components/card';
import CardConfig from 'common/components/card-config';
import {htmlUnescape, markdownToJsx} from 'common/utils/string-util';
import {ReportCardHeightTypeEnum} from 'common/proxies/enum-proxy';
import './index.scss';

export default class TextCard extends React.Component {
  static propTypes = {
    connectDragSource: PropTypes.func,
    disableConfig: PropTypes.bool,
    report: PropTypes.object.isRequired,
  };

  static defaultProps = {
    connectDragSource: (x) => x,
    disableConfig: true,
    report: {},
  };

  constructor(props) {
    super(props);
    this.onResize = this.onResize.bind(this);
  }

  state = {
    isScrolling: true,
    textHeight: 0,
  };

  componentDidMount() {
    this.observer = new ResizeObserver(debounce(this.onResize, 250));
    this.observer.observe(this._content);
  }

  UNSAFE_componentWillReceiveProps() {
    setTimeout(this.onResize);
  }

  componentWillUnmount() {
    this.observer.disconnect();
  }

  render() {
    const {connectDragSource, disableConfig, report} = this.props;

    const {isScrolling, textHeight} = this.state;

    const space = '16px';

    const {
      backgroundType,
      backgroundTypeColor,
      backgroundTypeGradientStart,
      backgroundTypeGradientEnd,
      cardHeight,
      cardHeightType,
      description,
      descriptionFontSize,
      descriptionTargetBlank,
      fontColor,
      fontColorType,
      horizontalAlignment,
      title,
      titleFontSize,
      verticalAlignment,
    } = report.meta || {};

    let background;
    switch (backgroundType) {
      case 'solid':
        background = backgroundTypeColor;
        break;
      case 'gradient':
        background = `linear-gradient(to bottom, ${backgroundTypeGradientStart} 0%, ${backgroundTypeGradientEnd} 100%)`;
        break;
      default:
        background = '#ffffff00';
        break;
    }

    const fontCol = fontColorType === 'custom' ? fontColor : fontColorType;

    const cardClassName =
      backgroundType === 'transparent'
        ? 'TextCard Card--transparent-corner-menu'
        : 'TextCard Card--corner-menu';

    let top = 0;
    if (verticalAlignment === 'center' && !isScrolling) {
      top = (cardHeight - textHeight) / 2;
    }
    if (verticalAlignment === 'bottom' && !isScrolling) {
      top = cardHeight - textHeight;
    }

    const style = (tag) => {
      if (tag === 'a') {
        return {
          color: fontCol,
          textDecoration: 'underline',
        };
      }
      return {};
    };

    return (
      <Card className={cardClassName} loading={false}>
        <div
          ref={(ref) => (this._content = ref)}
          style={{
            background,
            borderRadius: '5px',
            boxSizing: 'border-box',
            color: fontCol,
            height:
              cardHeightType === ReportCardHeightTypeEnum.CUSTOM.id
                ? `${cardHeight}px`
                : 'unset',
            overflow: 'auto',
          }}>
          <div
            className={'CardCaption'}
            style={{
              boxSizing: 'border-box',
              fontSize: descriptionFontSize,
              padding: space,
              position: 'relative',
              top,
              width: '100%',
              textAlign: horizontalAlignment,
            }}>
            <h1
              style={{
                color: fontCol,
                fontSize: titleFontSize,
                paddingBottom: '20px',
              }}>
              {htmlUnescape(title)}
            </h1>
            {markdownToJsx(htmlUnescape(description), {
              style,
              targetBlank: descriptionTargetBlank || false,
            })}
          </div>
        </div>

        {connectDragSource(
          <div
            style={{
              cursor: 'move',
              position: 'absolute',
              top: 0,
              left: 0,
              right: '1em',
              height: '2em',
            }}
          />,
        )}

        {!disableConfig ? (
          <CardConfig
            disableDownloadCsv={true}
            disableDownloadPointsCsv={true}
            reportId={report.id}
          />
        ) : null}
      </Card>
    );
  }

  onResize() {
    const node = this._content;
    const isScrolling = node ? node.clientHeight < node.scrollHeight : false;
    const textHeight = node ? node.children[0].clientHeight : 0;
    this.setState({isScrolling, textHeight});
  }
}
